import Vue from 'vue';

const groupState = {
  groups: [],
  contactsSelectedForGroup: [],
  myGroups: {},
  myGroupsIds: [],
  currentGroup: null,
  groupsState: 'idle',
  groupMemberIds: []
};

const groupActions = {
  async getGroupMembers(store, { id }) {
    let database = this._vm.firebase.database();
    store.commit("clearGroupMembers");
    const ref = database.ref().child("user_groups").orderByChild("group_id").equalTo(id);

    ref.on("child_added", async function(snap) {
      let user_group = snap.val();
      await store.dispatch("watchUser", user_group.user_id);
      store.commit("setGroupMember", user_group.user_id);
    });
  },
  async saveGroup(store, { group }) {
    let database = this._vm.firebase.database();
    const currentUserId = await store.dispatch("loggedInUserId");
    let ref = database.ref().child('groups');

    const isNewGroup = (group.id == undefined);
    let groupRef = isNewGroup ? ref.push() : ref.child(group.id);

    const groupRecord = Object.assign({}, group);
    if (isNewGroup) {
      groupRecord.created_at = this._vm.firebase.database.ServerValue.TIMESTAMP;
    }
    groupRecord.updated_at = this._vm.firebase.database.ServerValue.TIMESTAMP;
    groupRecord.creator_id = currentUserId;

    delete groupRecord.id;

    await groupRef.set(groupRecord);

    groupRecord.id = groupRef.key;

    if (isNewGroup) {
      await this.dispatch('ADD_USER_TO_GROUP', { group_id: groupRecord.id });
    }

    return Promise.resolve(groupRecord);
  },
  async getGroupById({ commit }, { id }) {
    const ref = this._vm.firebase.database().ref().child("groups").child(id);
    const snap = await ref.once("value");
    let group = snap.val();
    group.id = id;
    commit("setCurrentGroup", group);
  },
  setSelectedGroups({ commit }, group) {
    commit("setindexGroupsFilters", group);
    commit("RESET_RESOURCE_AND_SCROLL_STATE");
    localStorage.setItem('groups', JSON.stringify([group]));
  },
  async watchMyGroups(store) {
    store.commit("resetMyGroup");
    const currentUserId = await store.dispatch("loggedInUserId");
    const ref = this._vm.firebase.database().ref().child("user_groups").orderByChild("user_id").equalTo(currentUserId);

    ref.on("child_added", async function(snap) {
      store.commit("setGroupsStateLoaded");
      let user_group = snap.val();
      let group = await store.dispatch("getGroup", { id: user_group.group_id });
      if (group) store.commit("setMyGroup", group);
    });
  },
  async getGroup(store, { id }) {
    let ref = this._vm.firebase.database().ref().child("groups").child(id);

    ref.on("value", async function(snap) {
      let group = snap.val();
      // let group = Group.fromSnapshot(snap);
      if (group) store.commit("setGroup", { id, group });
    });
  },
};


const groupGetters = {
  getGroupsState: state => state.groupsState,
  getGroupMemberIds: (state) => {
    return state.groupMemberIds.sort((id) => {
      // currentGroup.isAdmin(id);
      return (id === state.currentGroup.creator_id) ? 0 : 1;
    });
  },
  getMyGroups: (state) => {
    // return state.myGroupsIds.map(id => state.myGroups[id])
    return state.myGroups;
  },
};

const groupMutations = {
  clearGroupMembers(state) {
    state.groupMemberIds = [];
  },
  setGroupMember(state, user) {
    state.groupMemberIds.push(user);
  },
  setindexGroupsFilters(state, group) {
    state.indexGroupsFilters = [group];
  },
  setSelectedGroups(state, indexGroupsFilters) {
    state.indexGroupsFilters = indexGroupsFilters;
  },
  setGroup(state, { id, group }) {
    group = {
      id: id,
      name: group.name,
      privacy: group.type,
      creator_id: group.creator_id
    };
    Vue.set(state.myGroups, id, group);
  },
  setCurrentGroup(state, group) {
    state.currentGroup = group;
  },
  addGroupToOffer(state, { index, id }) {
    if (state.resourceDraft.offers[index].group_ids.includes('to_public')) {
      state.resourceDraft.offers[index].group_ids = [id];
    } else {
      state.resourceDraft.offers[index].group_ids.push(id);
    }
  },
  setGroupsStateEmpty(state) {
    state.groupsState = 'empty';
  },
  setGroupsStateLoaded(state) {
    state.groupsState = 'loaded';
  },
};

export {
  groupActions,
  groupGetters,
  groupState,
  groupMutations
};
